import Caloritrack from "../components/FeatureCardSection/sections/FeatureCalorieTracking";
import Footer from "../components/Footer/Footer";
export default function CalorieTracking() {
  return (
    <>
      <Caloritrack />
      <Footer />
    </>
  );
}